import { PuttingEndpoint } from '@/domain/services/Api/Endpoint';
import { Resource } from '@/modules/ai-agents/AIAgents.types';
import { RoutesGetter, useRoutesDao } from '@/domain/dao/Routes';

type AIFieldResourceRequest = {
	resource: Resource;
	resourceSlug: string;
};

type AIFieldResourceResponse = {
	value: string;
};

const routes = useRoutesDao<{
	// eslint-disable-next-line @typescript-eslint/naming-convention
	field: {
		'ai-generate-response': () => void;
	};
}>();

const useApi = (field: string) => ({
	generateResponse: (resource: Resource, resourceSlug: string) =>
		PuttingEndpoint<AIFieldResourceRequest, AIFieldResourceResponse>(
			routes.field['ai-generate-response'] as RoutesGetter
		)({
			field,
		})({ resource, resourceSlug }),
});

export { useApi };
